import SoccerIcon from "../assets/soccer_icon.svg";
import TennisIcon from "../assets/tennis_icon.svg";
import PadelIcon from "../assets/padel_icon.svg";
import LogoTraid from "../assets/logo_orbitron_white.webp"
import LogoAilights from "../assets/ailights_black.webp"
import TraidImage from "../assets/skyscrapers.webp"
import ServicesImage from "../assets/services_image.webp"
import BrickWall from "../assets/brick-wall.webp"
import {useState} from "react";
import IsometricButton from "../base-components/IsometricButton";
import {Link} from "react-router-dom";
import BackgroundGrid from "../base-components/BackgroundGrid";

function Projects({ onChangeForm }) {

    const [sports, setSports] = useState([
        {
            id: "0",
            name: "SOCCER",
            image: {
                alt: "Soccer Image",
                src: "/images/futsal_crop.webp"
            },
            icon: SoccerIcon,
            isSelected: true
        },
        {
            id: "1",
            name: "TENNIS",
            image: {
                alt: "Tennis Image",
                src: "/images/tennis_crop.webp"
            },
            icon: TennisIcon,
            isSelected: false
        },
        {
            id: "2",
            name: "PADEL",
            image: {
                alt: "Padel Image",
                src: "/images/padel_crop.webp"
            },
            icon: PadelIcon,
            isSelected: false
        }
    ])

    const selectedImage = sports.find(sport => sport.isSelected).image

    const handleChangeSport = (sportId) => {
        setSports(prev => prev.map(sport => sport.id === sportId ? {...sport, isSelected: true} : {
            ...sport,
            isSelected: false
        }))
    }

    return (
        <div aria-label="Projects section">
            <section
                id="two-sequel"
                className="relative px-6 min-h-[50vw] overflow-hidden bg-gradient-to-b from-[#0E1512] via-[#0f1714] to-[#0E1512]"
            >
                <div className="flex flex-col items-center w-full mt-20
                                lg:flex-row
                                lg:items-start
                                lg:gap-0">
                    <div className="flex flex-col w-2/3 gap-10
                                    lg:w-1/3">
                        <div className="-mt-10">
                            <img
                                src="/2sequel_logo.webp"
                                alt="Logo 2Sequel"
                            />
                        </div>

                        <div className="flex flex-col gap-10
                                        lg:gap-40">
                            <div className="flex flex-col leading-none items-center
                                            lg:items-start">
                                <p className="text-[#bfcef1] text-[11vw] font-[900]
                                                lg:text-[6vw]">SCRIVI
                                </p>
                                <p className="text-[#7f9de3] text-[11vw] font-[900]
                                                lg:text-[6vw]">INTERROGA
                                </p>
                                <p className="text-[#295cd0] text-[11vw] font-[900]
                                                lg:text-[6vw]">VISUALIZZA
                                </p>
                            </div>

                            <div className="flex flex-row justify-center">
                                <Link to="/two-sequel">
                                    <IsometricButton
                                        backgroundColor="#bfcef1"
                                        sideColor="#7f9de3"
                                        bottomColor="#295cd0"
                                        textColor="#0E1512"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-row w-2/3 mt-10 justify-center
                                        lg:justify-end">
                        <img
                            className="w-full h-[50vw] object-contain lg:w-2/3"
                            src="/images/2sequel_section.webp"
                            alt="2Sequel demo"
                        />
                    </div>
                </div>
            </section>
            <section id="ailights" className="bg-light px-6 py-10 min-h-[50vw]"
                     style={{
                         backgroundColor: `#f0f0f0`,
                         backgroundImage: `url(${BrickWall})`,
                         opacity: 2
                     }}
            >
                <div className="flex flex-col items-center w-full mt-20
                                lg:flex-row
                                lg:items-start
                                lg:gap-0">
                        <div className="flex flex-col w-2/3 gap-10
                                    lg:w-1/3">
                        <div className="-mt-20">
                            <img src={LogoAilights} alt="Logo Ailights"></img>
                        </div>
                        <div className="flex flex-col gap-10
                                        lg:gap-40">
                            <div className="flex flex-col leading-none items-center
                                            lg:items-start">
                                <p className="text-dark text-[11vw] font-[900]
                                                lg:text-[6vw]">GIOCA</p>
                                <p className="text-dark-100 text-[11vw] font-[900]
                                                lg:text-[6vw]">RIPRENDI</p>
                                <p className="text-dark-200 text-[11vw] font-[900]
                                                lg:text-[6vw]">ANALIZZA</p>
                            </div>
                            <div className="flex flex-row justify-center">
                                <Link to="/ailights">
                                    <IsometricButton />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col w-2/3 mt-20">
                        <div className="flex flex-col gap-4">
                            {sports.map(sport =>
                                <div key={sport.id} className="flex flex-row justify-center
                                                               lg:justify-end">
                                    <button
                                        className={`${sport.isSelected ? "bg-dark-100" : "bg-dark-200 bg-opacity-30"} rounded-full flex justify-around items-center border-2 border-black w-full py-2
                                                   lg:w-1/3
                                                   lg:py-0`}
                                        onClick={() => handleChangeSport(sport.id)}>
                                        <span className="font-[900] text-white text-[4vw] lg:text-[2vw]">{sport.name}</span>
                                        <img src={sport.icon} alt="Tennis Icon" className="h-[4vw] lg:h-[2vw]"/>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="flex flex-row mt-10 justify-center
                                        lg:justify-end">
                            <img className="w-full h-[50vw] object-contain
                                            lg:w-2/3" src={selectedImage.src} alt={selectedImage.alt}>
                            </img>
                        </div>
                    </div>
                </div>
            </section>
            {/*<section*/}
            {/*    id="report"*/}
            {/*    className="relative px-6 min-h-[50vw] overflow-hidden bg-gradient-to-b from-[#0E1512] via-[#0f1714] to-[#0E1512]"*/}
            {/*>*/}
            {/*    <div className="relative z-10 flex flex-col mt-10 w-full gap-16 lg:flex-row">*/}
            {/*        <div className="flex flex-col w-full lg:w-1/3 gap-10">*/}
            {/*            <div className="flex flex-col gap-10 lg:gap-40 lg:mb-20">*/}
            {/*                <div className="flex flex-col leading-none items-center lg:items-start text-center lg:text-left">*/}
            {/*                    <h2 className="text-[7.5vw] font-[900] text-[#0b7c57]">RACCOGLI</h2>*/}
            {/*                    <h2 className="text-[7.5vw] font-[900] text-[#10B981]">ANALIZZA</h2>*/}
            {/*                    <h2 className="text-[7.5vw] font-[900] text-light">RENDICONTA</h2>*/}
            {/*                </div>*/}

            {/*                <div className="flex justify-center">*/}
            {/*                    <Link to="/report">*/}
            {/*                        <IsometricButton*/}
            {/*                            backgroundColor="#10B981"*/}
            {/*                            sideColor="#0b7c57"*/}
            {/*                            bottomColor="#F0F0F0"*/}
            {/*                            textColor="#F0F0F0"*/}
            {/*                        />*/}
            {/*                    </Link>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*        <div className="flex w-full lg:w-2/3">*/}
            {/*            <div className="flex w-full justify-center lg:justify-end">*/}
            {/*                <img*/}
            {/*                    src="/images/diagnosi.webp"*/}
            {/*                    alt="Report di sostenibilità e diagnosi energetiche"*/}
            {/*                    className="w-full h-[50vw] lg:w-2/3 object-contain drop-shadow-2xl"*/}
            {/*                />*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</section>*/}

            <section
                id="traid"
                className="relative bg-dark px-6 py-10 min-h-[50vw] overflow-hidden"
            >
                <BackgroundGrid
                    gridSize="80px"
                    gridColor="#10B981"
                    opacity={0.2}
                    fadeOffset={0.2}
                />
                <div className="relative z-10 flex flex-col items-center w-full gap-16
                                lg:flex-row
                                lg:mt-0">
                    <div className="flex flex-col w-2/3 gap-10 mt-20
                                    lg:w-1/3">
                        <div className="-mt-20">
                            <img src={LogoTraid} alt="Logo Traid"/>
                        </div>
                        <div className="flex flex-col gap-10
                                        lg:gap-40
                                        lg:mb-20   ">
                            <div className="flex flex-col leading-none items-center text-center lg:text-start
                                            lg:items-start">
                                <h2 className="text-[10vw] font-[900] text-green
                                                lg:text-[4.2vw] 2xl:text-[4.4vw]">SCOPRI</h2>
                                <h2 className="text-[10vw] font-[900] text-light
                                lg:text-[4.2vw] 2xl:text-[4.4vw]">I MERCATI</h2>
                                <h2 className="text-[10vw] font-[900] text-light
                                lg:text-[4.2vw] 2xl:text-[4.4vw]">CON L'AI</h2>
                                <h2 className="text-[10vw] font-[900] text-red
                                lg:text-[4.2vw] 2xl:text-[4.4vw]">E POTENZIA LE TUE ANALISI</h2>
                            </div>
                            <div className="flex flex-row justify-center">
                                <Link to="/traid">
                                    <IsometricButton
                                        sideColor="#DC2626"
                                        bottomColor="#F0F0F0"
                                        backgroundColor="#10B981"
                                        textColor="#F0F0F0"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className="flex flex-col w-full
                                    lg:w-2/3">
                        <img src={TraidImage} alt="Traid"/>
                    </div>
                </div>
            </section>
            <section className="bg-gradient-to-b from-dark to-black min-h-[50vw]">
                <div className="relative flex flex-col w-full
                                lg:flex-row">
                    <div className="flex flex-col h-full w-full">
                        <img src={ServicesImage} alt="Services" className="h-full object-cover"/>
                    </div>
                    <div className="right-6 absolute flex flex-col w-full gap-10 z-20">
                        <div className="flex flex-col gap-[4vw] mt-10
                                        lg:gap-32
                                        lg:mt-0">
                            <div className="flex flex-col leading-none text-end">
                                <h2 className="text-[8.5vw] font-[900] text-light">PENSIAMO</h2>
                                <h2 className="text-[8.5vw] font-[900] text-light">ALLA</h2>
                                <h2 className="text-[8.5vw] font-[900] text-light">SOLUZIONE</h2>
                                <h2 className="text-[8.5vw] font-[900] text-light">ADATTA A TE,</h2>
                                <h2 className="text-[8.5vw] font-[900] text-blue-100">INSIEME</h2>
                            </div>
                            <div className="flex flex-row justify-end">
                                <button
                                    className="rounded-full border-[0.4vw] border-light text-light text-[4vw] font-[400] hover:bg-hero mb-20 inline-block text-center py-[1vw] px-[2vw] lg:text-[2vw]"
                                    onClick={onChangeForm}
                                >
                                    CONTATTACI
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Projects;
